import type { IBranch, IServiceResponse } from '@sravni/types/lib/branches';

import type { PayloadAction } from '@reduxjs/toolkit';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import * as branchesService from '../../services/branches';
import reTry from '../../utils/reTry';
import type { GlobalState } from '../index';

const reTryFetchBranches = reTry(branchesService.fetchBranches);

export interface IState {
  branches: Record<
    string,
    {
      loading: boolean;
      items: IBranch[];
      totalCount: number;
    }
  >;
}

const initialState: IState = {
  branches: {},
};

export const fetchBranches = createAsyncThunk<any, any, { state: GlobalState }>(
  'products/fetchMore',
  async (params) => {
    const data = await reTryFetchBranches(params);

    return data;
  },
);

const branchesSlice = createSlice({
  name: 'branches',
  initialState,
  reducers: {
    setBranches: (
      state,
      { payload }: PayloadAction<Partial<IServiceResponse> & { branchesKey: string; loading: boolean }>,
    ) => {
      state.branches = {
        ...state.branches,
        [payload.branchesKey]: {
          loading: payload.loading,
          items: payload.items,
          totalCount: payload.total,
        },
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBranches.pending, (state, { meta }) => {
        const { organizationIds: organizationAlias } = meta.arg;
        state.branches = {
          ...state.branches,
          [organizationAlias]: {
            loading: true,
            totalCount: 0,
            items: [],
          },
        };
      })
      .addCase(fetchBranches.fulfilled, (state, { payload, meta }) => {
        const { items, total } = payload;

        const { organizationIds: organizationAlias } = meta.arg;
        state.branches = {
          ...state.branches,
          [organizationAlias]: {
            loading: false,
            items,
            totalCount: total,
          },
        };
      })
      .addCase(fetchBranches.rejected, (state, { meta }) => {
        const { organizationIds: organizationAlias } = meta.arg;
        state.branches = {
          ...state.branches,
          [organizationAlias]: {
            loading: false,
            items: [],
            totalCount: 0,
          },
        };
      });
  },
});

const { actions, reducer } = branchesSlice;

export const { setBranches } = actions;

export default reducer;
